export default __webpack_public_path__ + "static/media/Color_Pink.02faaceb.svg";